import React, { useState } from "react";

const ContactForm = () => {
  const [result, setResult] = useState("");

  const onSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setResult("Sending....");
    const formData = new FormData(event.currentTarget);

    // IMPORTANT: Replace with your own Web3Forms Access Key
    formData.append("access_key", "YOUR_ACCESS_KEY_HERE");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (data.success) {
      setResult("Form Submitted Successfully!");
      (event.target as HTMLFormElement).reset();
    } else {
      console.log("Error", data);
      setResult(data.message);
    }
  };

  return (
    <div className="rounded-lg bg-white p-8 shadow-md sm:p-10">
      <form onSubmit={onSubmit}>
        <input
          type="hidden"
          name="subject"
          value="New Contact Form Submission from Nunya"
        />
        <div className="space-y-6">
          <div>
            <label
              htmlFor="name"
              className="mb-1 block text-sm font-medium text-gray-700"
            >
              Full Name
            </label>
            <input
              type="text"
              name="name"
              id="name"
              required
              className="w-full rounded-md border border-gray-300 px-4 py-2 shadow-sm focus:border-nature-green focus:ring-nature-green"
            />
          </div>
          <div>
            <label
              htmlFor="email"
              className="mb-1 block text-sm font-medium text-gray-700"
            >
              Email Address
            </label>
            <input
              type="email"
              name="email"
              id="email"
              required
              className="w-full rounded-md border border-gray-300 px-4 py-2 shadow-sm focus:border-nature-green focus:ring-nature-green"
            />
          </div>
          <div>
            <label
              htmlFor="message"
              className="mb-1 block text-sm font-medium text-gray-700"
            >
              Message
            </label>
            <textarea
              name="message"
              id="message"
              rows={5}
              required
              className="w-full rounded-md border border-gray-300 px-4 py-2 shadow-sm focus:border-nature-green focus:ring-nature-green"
            ></textarea>
          </div>
          <div>
            <button
              type="submit"
              className="w-full rounded-md bg-nature-green px-4 py-3 font-bold text-white transition-colors duration-300 hover:bg-nature-green-dark focus:outline-none focus:ring-2 focus:ring-nature-green focus:ring-offset-2"
            >
              Send Message
            </button>
          </div>
        </div>
        {result && <p className="mt-4 text-center text-gray-600">{result}</p>}
      </form>
    </div>
  );
};

export default ContactForm;
